module.exports = __webpack_public_path__ + "static/media/Trail.2bdaa129.jpeg";